import React from 'react';
import { Row } from 'reactstrap';
import DonutContainer from 'components/donut/DonutContainer';
import CarouselContainer from 'components/carousel/CarouselContainer';
import HorizontalBarChartContainer from 'components/horizontal-bar-chart/HorizontalBarChartContainer';
import TrendContainer from 'components/trends/TrendContainer';
import PlaneContainer from 'components/plane/PlaneContainer';

let page = 'movies';
let displayPageName = 'Movies';

class MoviesOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidUpdate() {
        // Code to move the pvtUnused cell after the component mounts
        let table = document.querySelector('.pvtUi tbody');
        if (table && table.rows.length < 3) {
            let firstRow = table.rows[0];
            let secondRow = table.rows[1];
            //create third row if not there.
            let thirdRow = table.insertRow(2);
            thirdRow.appendChild(secondRow.children[1]);
            thirdRow.appendChild(secondRow.children[1]);

            //get pvtTables and pvtCols and move to second row
            //remove pvtTables and pvtCols from first row
            let pvtVals = firstRow.children[1];
            let pvtCols = firstRow.children[2];
            secondRow.appendChild(pvtVals);
            secondRow.appendChild(pvtCols);

            let pvtUnusedCell = secondRow.querySelector('.pvtUnused');

            pvtUnusedCell.classList.remove('pvtVertList');
            pvtUnusedCell.classList.add('pvtHorizList');

            if (pvtUnusedCell) {
                firstRow.appendChild(pvtUnusedCell);
            }
        }
    }

    render() {
        let dashboard = (
            <div>
                <CarouselContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    contentType="Movies"
                    forceReloadAll={this.props.forceReloadAll}
                    title="Movie Rankings"
                    workbenchTitle="titles"
                    page={page}
                    pageName={displayPageName}
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    app={this.props.app}
                />

                <Row>
                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType="row"
                        forceReloadAll={this.props.forceReloadAll}
                        page={page}
                        pageName={displayPageName}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        allowedApps={this.props.allowedApps}
                        app={this.props.app}
                    />
                </Row>

                <TrendContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    contentType="Movies"
                    forceReloadAll={this.props.forceReloadAll}
                    title="Trends"
                    workbenchTitle="trends"
                    page={page}
                    pageName={displayPageName}
                    key="movies_overview_trend_1"
                    id="movies_overview_trend_1"
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    app={this.props.app}
                />

                <PlaneContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    contentType="Movies"
                    title="Cabin Class"
                    workbenchTitle="cabin_class_viewing"
                    page={page}
                    pageName={displayPageName}
                    forceReloadAll={this.props.forceReloadAll}
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    app={this.props.app}
                />

                <Row>
                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="Movies"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Routes"
                        workbenchTitle="routes"
                        page={page}
                        pageName={displayPageName}
                        reportType="routes"
                        color="#F7A77F"
                        routes={true}
                        key="movies_overview_routes_1"
                        id="movies_overview_routes_1"
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        app={this.props.app}
                    />

                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="Movies"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Categories"
                        workbenchTitle="categories"
                        page={page}
                        pageName={displayPageName}
                        reportType="categories"
                        color="#77AFD7"
                        key="movies_overview_categories_1"
                        id="movies_overview_categories_1"
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        app={this.props.app}
                    />
                </Row>

                <Row>
                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="Movies"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Genres"
                        workbenchTitle="genres"
                        page={page}
                        pageName={displayPageName}
                        reportType="genres"
                        color="#954F95"
                        key="movies_overview_genres_1"
                        id="movies_overview_genres_1"
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        app={this.props.app}
                    />

                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="Movies"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Languages"
                        workbenchTitle="languages"
                        page={page}
                        pageName={displayPageName}
                        reportType="languages"
                        color="#7FCECD"
                        key="movies_overview_languages_1"
                        id="movies_overview_languages_1"
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        app={this.props.app}
                    />
                </Row>
            </div>
        );

        return <div>{dashboard}</div>;
    }
}

export default MoviesOverview;
